import  { useState } from 'react'
import {  useParams } from 'react-router-dom';
import Loader from '../Loader/buttonLoad';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import moment from 'moment';
import { useUserClaimSlot, useUserRedeemWalletReward } from '../modals/api/api';



const RedeemReward = () => {
    const { id } = useParams()
    const [page, setPage] = useState(0);

   

    const [rowsPerPage, setRowsPerPage] = useState(10);

    const { data: SlotHistoryList, isLoading } = useUserRedeemWalletReward({
        page,
        size: rowsPerPage,
        slotId: id
    })


    const totalPages = SlotHistoryList?.count ? Math.ceil(SlotHistoryList.count / rowsPerPage) : 0;


    const handlePageChange = (newPage) => {
        if (newPage >= 0 && newPage < totalPages) {
            setPage(newPage);
        }
    };



    const slotClaim = useUserClaimSlot()



    return (





        <div>
            <div className="">
                {(isLoading || slotClaim.isLoading) && <Loader />}
                <div className='container'>

                    <div className='row'>
                        <div className="col-lg-12">


                            <div>

                                <div className='row'>
                                    <div className="col-lg-12">
                                        <div className="appcard mb-4 px-0 pb-2 cardbg">
                                            <div className="pageContent def-py-30">
                                                <div className='container'>

                                                    <div className="px-4 mb-3">
                                                        <div className='row justify-content-between'>
                                                            <div className="col-md-6 mb-2 mb-md-0 text-center text-md-left">
                                                                <div className='d-inline-flex g-8 align-items-center'>
                                                                    <span className='fs-18 fw-400 text-white-60'>Show</span>
                                                                    <div className='form-group mb-0 formInputs gradientBg'>
                                                                        <select className='form-control' onChange={(e) => {
                                                                            setRowsPerPage(Number(e.target.value));
                                                                            setPage(0);
                                                                        }}>
                                                                            <option value="10">10</option>
                                                                            <option value="30">30</option>
                                                                            <option value="50">50</option>
                                                                        </select>
                                                                    </div>
                                                                    <span className='fs-18 fw-400 text-white-60'>entries</span>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className='table-responsive mb-3'>
                                                        <table className='table myapptable table-hover table-borderless mb-0'>
                                                            <thead>
                                                                <tr>
                                                                    <th className='text-center'>S.No</th>
                                                                    <th className='text-center'>Slot ID</th>
                                                                    <th className='text-center'>User Name</th>
                                                                    <th className='text-center'>Reward Amount</th>
                                                                    <th className='text-center pr-4'>Expire Date & Time</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {SlotHistoryList?.data?.length > 0 ?
                                                                    SlotHistoryList?.data?.map((v, i) => {

                                                                        return (
                                                                            <tr key={v?._id}>
                                                                                <td align='center'>{page * rowsPerPage + (i + 1)}</td>
                                                                                <td align='center'>{v?.slotId}</td>
                                                                                <td align='center'>{v?.userName}</td>
                                                                                <td align='center'>{parseFloat(Number(v?.rewardAmount)).toFixed(4)} TPL</td>
                                                                              
                                                                                <td className='text-center pr-4 text-nowrap'>
                                                                                    <span>{moment(v?.expiredAt).format("DD/MM/YYYY | hh:mm A")}</span>
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    }) :
                                                                    <tr>
                                                                        <td colSpan="6" className="text-center">No data found</td>
                                                                    </tr>
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    {SlotHistoryList?.count &&
                                                        <div className="px-4">
                                                            <div className='row'>
                                                                <div className='col-lg-12'>

                                                                    <Pagination aria-label="Page navigation" className='customPagination'>
                                                                        <PaginationItem disabled={page === 0}>
                                                                            <PaginationLink previous href="#" onClick={() => handlePageChange(page - 1)} className='prevbtn'>
                                                                                <i className='bi bi-arrow-left align-bottom'></i> Previous
                                                                            </PaginationLink>
                                                                        </PaginationItem>
                                                                        <span className='number'>

                                                                            {page < 3 ? (
                                                                                // Show first three pages if the current page is less than 3
                                                                                Array.from({ length: Math.min(3, totalPages) }, (_, index) => (
                                                                                    <PaginationItem key={index} active={index === page} className={`${index === page ? 'customPagination active' : 'customPagination'}`}>
                                                                                        <PaginationLink href="#" onClick={() => handlePageChange(index)}>
                                                                                            {index + 1}
                                                                                        </PaginationLink>
                                                                                    </PaginationItem>
                                                                                ))
                                                                            ) : (
                                                                                // Show a dynamic range around the current page if the current page is 3 or greater
                                                                                <>
                                                                                    {page > 0 && (
                                                                                        <PaginationItem key={0} className="customPagination">
                                                                                            <PaginationLink href="#" onClick={() => handlePageChange(0)}>
                                                                                                1
                                                                                            </PaginationLink>
                                                                                        </PaginationItem>
                                                                                    )}

                                                                                    {page > 1 && (
                                                                                        <PaginationItem disabled>
                                                                                            <PaginationLink href="#">...</PaginationLink>
                                                                                        </PaginationItem>
                                                                                    )}

                                                                                    {Array.from({ length: 3 }, (_, index) => (
                                                                                        <PaginationItem key={page - 1 + index} active={page - 1 + index === page} className={`${page - 1 + index === page ? 'customPagination active' : 'customPagination'}`}>
                                                                                            <PaginationLink href="#" onClick={() => handlePageChange(page - 1 + index)}>
                                                                                                {page - 1 + index + 1}
                                                                                            </PaginationLink>
                                                                                        </PaginationItem>
                                                                                    ))}

                                                                                    {page < totalPages - 2 && (
                                                                                        <PaginationItem disabled>
                                                                                            <PaginationLink href="#">...</PaginationLink>
                                                                                        </PaginationItem>
                                                                                    )}

                                                                                    {page < totalPages - 1 && (
                                                                                        <PaginationItem key={totalPages - 1} className="customPagination">
                                                                                            <PaginationLink href="#" onClick={() => handlePageChange(totalPages - 1)}>
                                                                                                {totalPages}
                                                                                            </PaginationLink>
                                                                                        </PaginationItem>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </span>

                                                                        <PaginationItem disabled={page === totalPages - 1}>
                                                                            <PaginationLink next href="#" onClick={() => handlePageChange(page + 1)} className='nextbtn'>
                                                                                Next <i className='bi bi-arrow-right align-bottom'></i>
                                                                            </PaginationLink>
                                                                        </PaginationItem>
                                                                    </Pagination>
                                                                </div>
                                                            </div>
                                                        </div>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default RedeemReward;